<!-- auto-generated by Trent -->
<script lang="ts">
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  // @ts-nocheck
  import Post from '$lib/layouts/post.svelte';
  import ImgZoom from '$lib/components/image_zoom.svelte';
  import Video from '$lib/components/video.svelte';
  import CodeCopy from '$lib/components/code_copy.svelte';
  import InfoBox from '$lib/components/info_box.svelte';
</script>

<Post>
  <article slot="post_content">
    <style>
      .align {
        display: flex;
      }
      .align a {
        padding: 0.5rem;
      }
    </style>

    <p>
      大家好，我是 Trent，歡迎光臨本站，本站的定位是股癌頻道的歷史本文。
      <br />
      主要分享股癌 Podcast 的逐字稿。 由於成立時間尚晚，會逐步將早期集數補齊。 在這裡您可以使用搜尋功能，找到節目曾經說過的旅遊景點、餐廳、電影、書籍、音樂等等曾在節目中提過的一切。
      <br />
      內容若有錯誤，請以股癌節目為主，時間允許的話，煩請聯繫本站改正，愛您。
      <br />
    </p>
    <h2 id="lian2-luo4-wo3"><a href="#lian2-luo4-wo3">聯絡我：</a></h2>
    <ul>
      <li>
        Email：
        <a href="mailto:hi@gooayetranscript.com"><strong>hi@gooayetranscript.com</strong></a>
      </li>
    </ul>
  </article>
</Post>

<!-- <style lang="scss">
  article :global(*:not(h2):not(.code-block):not(.code-block *):not(aside):not(aside *)) {
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
  }
  article :global(.i-fluent-emoji-flat-open-file-folder) {
    ~ :global(ul),
    ~ :global(ul li) {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
</style> -->
